import React  from "react";


import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Contact() {
    AnimationFileLoader();

  return (
    <>

      {/*  Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/*  End Author */}

    {/*  Contact */}
    <div className="pt-120 pb-120 d-flex align-items-center">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    {/*  Section Title */}
                    <div className="section-title text-white text-center">
                        <h2>Get In Touch</h2>
                        <p>The top NFTs on Anefty, ranked by volume, floor price and other statistics. "Multiple" if you
                            want to sell by ones collectibles upload your work likes image, video, audio times htmlFor
                            Anefty.</p>
                    </div>
                    {/*  End Section Title */}
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    {/*  Card */}
                    <div className="card">
                        <div className="card-body contact-form-wrap">
                            {/*  Contact Form */}
                            <form action="sendmail.php" className="contact-form">

                                <h3 className="pb-1">Quick Contact Us</h3>
                                <div className="form-group">
                                    <label htmlFor="name">Full Name</label>
                                    <input type="text" name="name" className="form-control" id="name"
                                        placeholder="Example @alex_anderson"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email address</label>
                                    <input type="email" name="email" className="form-control" id="email"
                                        placeholder="support@anefty.com" />
                                </div>
                               <div className="form-group">
                                    <div className="row justify-content-between">
                                        <label htmlFor="collection" className="col-md-5">Select Country</label>
                                        <span className="info col-md-7 d-flex opacity-50 justify-content-md-end mb-3 mb-lg-0">*Please Select Your Country</span>
                                    </div>
                                    <select id="collection" name="country" className="form-control">
                                        <option value="select_collection">Select Country</option>
                                        <option value="bangladesh">Bangladesh</option>
                                        <option value="pakistan">Pakistan</option>
                                        <option value="honolulu">Honolulu</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="subject">Subject</label>
                                    <input type="text" name="subject" className="form-control" id="subject"
                                        placeholder="Services Request"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Message</label>
                                    <textarea id="message" name="message" className="form-control"
                                        placeholder="Write your Message"></textarea>
                                </div>
                                <div className="pt-2">
                                    <button type="submit" className="btn">
                                        <img src="/img/icons/btn_submit.svg" alt="" className="svg"/> Send Message
                                    </button>
                                </div>
                                <div className="form-response mt-3"></div>
                            </form>
                            {/*  End Contact Form */}
                        </div>
                    </div>
                    {/*  End Card */}
                </div>
            </div>
        </div>
    </div>
    {/*  End Contact */}

    </>
  );
}

export default Contact;
